import { extend, override } from 'flarum/common/extend';
import BsiIcon, { buttonIcon } from './components/BsiIcon';
import { t } from './helpers';
export default function polishAuth() {
  for (const [component, icon, introduction] of [['LogInModal', 'sign-in', 'login_intro'], ['SignUpModal', 'user-plus', 'signup_intro']]) {
    const module = 'flarum/forum/components/' + component;
    override(module, 'title', function (original) {
      return m("span", {
        className: "BsiAuthHeading"
      }, m("span", {
        className: "BsiAuthEmblem"
      }, m(BsiIcon, {
        name: icon
      })), m("span", null, original()));
    });
    extend(module, 'body', body => {
      body.unshift(m("p", {
        className: "BsiAuthIntro"
      }, t('auth.' + introduction)));
    });
    extend(module, 'fields', items => {
      for (const [field, name] of Object.entries({
        identification: 'user-circle',
        username: 'user-circle',
        email: 'envelope-simple',
        password: 'lock-key'
      })) {
        if (!items.has(field)) continue;
        const group = items.get(field);
        group.children = group.children.map(child => child?.tag === 'input' ? m("div", {
          className: "BsiAuthInput"
        }, m(BsiIcon, {
          name: name
        }), child) : child);
      }
      const submit = items.has('submit') && items.get('submit').children?.find(child => child?.attrs?.type === 'submit');
      if (submit) submit.attrs.icon = buttonIcon(icon);
    });
  }
}